import OrderCargoOrderFinishedListRequest, {
  OrderCargoOrderFinishedListRequestOrder,
  OrderCargoOrderFinishedListRequestPublicStatus,
} from "../../../../../api/raily/order/cargo-order/finished/list/order-cargo-order-finished-list.request";
import ExecutionStatus from "../../../../../types/execution-status";
import PublicStatus from "../../../../../types/public-status";
import paginationService from "../../../../../utils/pagination/pagination.service";
import OrderCargoOrderFinishedListParams, {
  OrderCargoOrderFinishedListParamsSortKey,
} from "./order-cargo-order-finished-list-params";

const createPublicStatus = (
  status: PublicStatus | undefined,
): OrderCargoOrderFinishedListRequestPublicStatus | undefined => {
  switch (status) {
    case PublicStatus.PRIVATE:
      return OrderCargoOrderFinishedListRequestPublicStatus.PRIVATE;
    case PublicStatus.PUBLIC:
      return OrderCargoOrderFinishedListRequestPublicStatus.PUBLIC;
    case PublicStatus.PUBLISHED:
      return OrderCargoOrderFinishedListRequestPublicStatus.PUBLISHED;
    default:
      return undefined;
  }
};

const createOrder = (
  order: OrderCargoOrderFinishedListParamsSortKey | undefined,
): OrderCargoOrderFinishedListRequestOrder | undefined => {
  switch (order) {
    case OrderCargoOrderFinishedListParamsSortKey.ORDER_START_DATE_ASC:
      return OrderCargoOrderFinishedListRequestOrder.START_TIME_ASC;
    case OrderCargoOrderFinishedListParamsSortKey.ORDER_START_DATE_DESC:
      return OrderCargoOrderFinishedListRequestOrder.START_TIME_DESC;
    case OrderCargoOrderFinishedListParamsSortKey.INTERNAL_ORDER_ID_ASC:
      return OrderCargoOrderFinishedListRequestOrder.HUMAN_ID_ASC;
    case OrderCargoOrderFinishedListParamsSortKey.INTERNAL_ORDER_ID_DESC:
      return OrderCargoOrderFinishedListRequestOrder.HUMAN_ID_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: OrderCargoOrderFinishedListParams,
): OrderCargoOrderFinishedListRequest => {
  return {
    internalOrderId: params.internalOrderId ? [params.internalOrderId] : [],
    address: params.address ? [params.address] : [],
    client: params.client ? [params.client] : [],
    taxi: params.taxi ? [params.taxi] : [],
    dispatch: params.dispatch ? [params.dispatch] : [],
    driver: params.driver ? [params.driver] : [],
    startAddress: params.pickupAddress ? [params.pickupAddress] : undefined,
    endAddress: params.destinationAddress ? [params.destinationAddress] : [],
    midAddress: params.intermediateAddress ? [params.intermediateAddress] : [],
    externalId: params.externalOrderId ? [params.externalOrderId] : [],
    passenger: params.passenger ? [params.passenger] : [],
    order: createOrder(params.sortKey),
    publicStatus: createPublicStatus(params.publicStatus),
    isApproved: params.isUrgent,
    isCancelled: params.executionStatus
      ? params.executionStatus === ExecutionStatus.CANCELLED
      : undefined,
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    startTimeSince: params.orderStartDateFrom,
    startTimeTo: params.orderStartDateTo,
    excludeFleetPartners: params.excludeFleetPartner
      ? [params.excludeFleetPartner]
      : [],
    fleetPartners: params.fleetPartner ? [params.fleetPartner] : [],
  };
};

const orderCargoOrderFinishedListParamsFactory = {
  create,
};

export default orderCargoOrderFinishedListParamsFactory;
